import React from 'react';
import softwareImg from './Logos/Assets/software.png';
import './Styles/Subsystems.css';

const SoftwarePage = () => {
    return (
        <div className="subsystem-page">
            <h1>Software Subsystem</h1>
            <img src={softwareImg} alt="Software" className="subsystem-image" />
            <p>
                The Software team controls how TONE thinks and responds in real time. We make sure every movement is smooth and every command from the driver is followed right away. Our work lets the robot act fast, stay steady, and adapt to what’s happening in the arena.
                <br /><br />
                We also track how the robot is performing during each match and make updates to improve it for next time. Great software means better control, faster reactions, and smarter decisions in the heat of battle. It’s how we bring the whole machine to life.
            </p>
        </div>
    );
};

export default SoftwarePage;